<!-- Footer -->
<footer id="contact" [ngClass]="footerClass">
  <div class="container">
    <ng-content select="[footerContent]"></ng-content>
  </div>
</footer>
<!-- Footer END -->
